<template>
    <div>
      <div style="text-align: center">
        <h3>Tambah Device</h3>
      </div>
      <br />
      <form v-on:submit.prevent="addDevice">
        <label>Nama Device</label>
        <input type="text" class="form-control" v-model="form.name" autofocus required />
        <br />
        <label>Nomor HP</label>
        <input type="number" class="form-control" v-model="form.number" autofocus required />
        <br />

        <div class="button-group d-flex pt-25">
          <br>
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              Tambah
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: "",
          number: "",
          pair_method: "qr",
          multidevice: "1",
          type: "unofficial"
        },
      };
    },
    mounted() {
  
    },
    methods: {
      async addDevice(){
        try{
          let request = { ...this.form, pair_method: 'qr' }
          let response = await this.$store.dispatch('device_create', request)
          
          this.$toast.success(response.data.message);
          this.$root.$emit("toggle_modal", "new_device")
          this.$root.$emit("refresh_table", true)
          this.$router.push('/device/scan?id=' + response.data.data?.id)
        }catch(err){
          this.$toast.error(err.response.data.message);
        }
      },
    },
  };
  </script>
  
